import { render, staticRenderFns } from "./CustomerCredit.vue?vue&type=template&id=5f0b6a90&scoped=true&"
import script from "./CustomerCredit.vue?vue&type=script&lang=js&"
export * from "./CustomerCredit.vue?vue&type=script&lang=js&"
import style1 from "./CustomerCredit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b6a90",
  null
  
)

export default component.exports